<template>
  <div class="comp-container__white-board">
    <div
      v-show="!isBoardReady"
      class="white-board-loading-mask"
      tabindex="-1"
      aria-busy="true"
    >
      <div class="white-board-loading-content">
        <i class="el-icon-loading" aria-label="加载中"></i>
        <div class="white-board-loading-text">白板加载中</div>
      </div>
    </div>
    <div v-show="isBoardReady" id="comp-container__white-board-sketch"></div>
    <template v-if="allIsReady && !isRecordPage && !isTransparent">
      <template v-if="showMobileToolbar">
        <!-- 工具栏 -->
        <!-- 手机端工具栏 -->
        <mobile-toolbar
          @on-log="handleLog"
          :isAudioOpen="isAudioOpen"
          :isHorizontal="isHorizontal"
          :isWhiteBoard="isWhiteBoard"
        />
      </template>
      <template v-else-if="isWhiteBoard">
        <toolbar :isMGAppInPad="isMGAppInPad" />
        <!-- 元素工具栏 -->
        <!-- 只有老师可以控制 -->
        <!-- 白板页面控制器 -->
        <div
          v-if="controlPage && whiteboardType === 'whiteboard'"
          class="bottom-controller-wrap"
        >
          <page-controller />
          <scale-controller />
        </div>
        <!-- 只有老师可以控制 -->
        <!-- 课件页面控制器 -->
        <courseware-controller
          :isVideo="isVideo"
          v-if="controlPage && whiteboardType === 'courseware'"
        ></courseware-controller>
      </template>
      <element-toolbar />
    </template>
  </div>
</template>

<script>
import MobileToolbar from "./mobile/MobileToolbar.vue";
import ScaleController from "./components/ScaleController.vue";
import PageController from "./components/PageController.vue";
import ElementToolbar from "./components/ElementToolbar.vue";
import { mapMutations, mapState } from "vuex";
import Toolbar from "./components/Toolbar.vue";
import CoursewareController from "./courseware/CoursewareController.vue";
import { uploadLiveLog } from "@saas/components/src/utils/log";
// import {
//   LiveSet,
//   DragWrap,
//   UploadCourseware,
//   isImage,
//   isVideo,
//   isDoc,
// } from "@saas/components";
const isImage = (fileName) => {
  const reg = /(\.jpg|\.jpeg|\.png|\.gif|\.bmp)$/i;
  return reg.test(fileName);
};
// 根据文件名判断是否是视频
const isVideo = (fileName) => {
  const reg =
    /(\.mp4|\.avi|\.rmvb|\.wmv|\.flv|\.mov|\.mpg|\.mpeg|\.rm|\.asf|\.3gp|\.mkv|\.3g2|\.h264|\.m4v|\.mj2|\.ogg|\.ogv|\.qt|\.vob|\.webm|\.f4v)$/i;
  return reg.test(fileName);
};
// 根据文件名判断是否是文档
const isDoc = (fileName) => {
  const reg = /(\.pdf|\.doc|\.docx|\.ppt|\.pptx|\.xls|\.xlsx)$/i;
  return reg.test(fileName);
};
const getProcessVersions = () => {
  if (typeof process === "undefined") {
    return null;
  }
  return {
    electron: process.versions?.electron,
    chrome: process.versions?.chrome,
    node: process.versions?.node,
    v8: process.versions?.v8,
  };
};
const getH5PPTFrameInfo = () => {
  const board = document.querySelector("#comp-container__white-board-sketch");
  const frames = Array.from(board?.querySelectorAll("iframe") || []);
  return {
    iframeCount: frames.length,
    frames: frames.slice(0, 5).map((frame) => {
      const rect = frame.getBoundingClientRect();
      return {
        id: frame.id,
        name: frame.name,
        className: frame.className,
        src: frame.src,
        visible: rect.width > 0 && rect.height > 0,
        rect: {
          width: Math.round(rect.width),
          height: Math.round(rect.height),
          left: Math.round(rect.left),
          top: Math.round(rect.top),
        },
      };
    }),
  };
};
const parseSdkReportLog = (data = {}) => {
  if (typeof data !== "string") {
    return data || {};
  }
  try {
    return JSON.parse(data);
  } catch (error) {
    return { raw: data };
  }
};
const getWhiteBoardRuntimeInfo = () => ({
  isElectron: !!window.isElectron,
  hasLiveElectronApi: !!window.LiveElectronApi,
  userAgent: navigator.userAgent,
  platform: navigator.platform,
  language: navigator.language,
  online: navigator.onLine,
  href: window.location.href,
  protocol: window.location.protocol,
  origin: window.location.origin,
  isSecureContext: window.isSecureContext,
  crossOriginIsolated: window.crossOriginIsolated,
  documentReadyState: document.readyState,
  visibilityState: document.visibilityState,
  devicePixelRatio: window.devicePixelRatio,
  innerSize: `${window.innerWidth}x${window.innerHeight}`,
  screenSize: `${window.screen?.width}x${window.screen?.height}`,
  processVersions: getProcessVersions(),
  h5PPTFrameInfo: getH5PPTFrameInfo(),
});
export default {
  props: {
    isTransparent: {
      type: Boolean,
      default: false,
    }, //白板是否透明
    isAudioOpen: {
      type: Boolean,
      default: true,
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
    showMobileToolbar: {
      type: Boolean,
      default: false,
    },
    isImReady: {
      type: Boolean,
      default: false,
    },
    lessonId: {
      type: Number,
      default: 0,
    },
    controlPage: {
      type: Boolean,
      default: false,
    },
    isWhiteBoard: {
      type: Boolean,
      default: false,
    },
    isRecordPage: {
      type: Boolean,
      default: false,
    },
    isMGAppInPad: {
      type: Boolean,
      default: false,
    },
    isHXApp: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Toolbar,
    ElementToolbar,
    PageController,
    ScaleController,
    MobileToolbar,
    CoursewareController,
  },
  data() {
    return {
      isVideo: false,
    };
  },
  computed: {
    ...mapState("live", [
      "whiteBoardService",
      "whiteboardType",
      "roomInfo",
      "imService",
    ]),
    ...mapState("whiteBoard", ["isBoardReady"]),
    allIsReady() {
      return this.isBoardReady && this.isImReady;
    },
    coursewareList() {
      return this.roomInfo.doc || [];
    },
  },
  created() {},
  beforeDestroy() {
    if (this.whiteBoardService && this.whiteBoardService?.off) {
      this.whiteBoardService.off("dataSynced");
      this.whiteBoardService.off("ready");
      this.whiteBoardService.off("tabGotoBoard");
      this.whiteBoardService.off("tabSwitchFile");
      this.whiteBoardService.off("scaleBoard");
      this.whiteBoardService.off("error");
      this.whiteBoardService.off("videoVolumeChanged");
    }
  },
  watch: {
    whiteBoardService: {
      handler(val) {
        if (val) {
          this.init();
        }
      },
      immediate: true,
    },
    isWhiteBoard: {
      handler(val) {
        if (this.whiteBoardService?.setDrawEnable) {
          this.whiteBoardService.setDrawEnable(val);
        }
      },
      immediate: true,
    },
    "roomInfo.isStudent": {
      handler(val) {
        if (this.whiteBoardService?.setVideoControlEnable && val) {
          this.whiteBoardService.setVideoControlEnable(false);
        }
      },
      immediate: true,
    },
    controlPage: {
      handler(val) {
        if (this.isMGAppInPad || this.isHXApp) {
          if (val) {
            this.whiteBoardService?.setVideoControlEnable(true);
          } else {
            this.whiteBoardService?.setVideoControlEnable(false);
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    ...mapMutations("whiteBoard", ["setBoardReady", "setCurrentFileInfo"]),
    ...mapMutations("live", ["setRoomInfo", "setWhiteboardType"]),
    init() {
      this.logWhiteBoardDiagnostic("诊断白板运行环境", {
        action: "whiteboard_runtime_env",
      });
      this.whiteBoardService.on("dataSynced", (data) => {
        this.$emit("data-synced", data);
        console.log("data-synced", data);
      });
      this.whiteBoardService.on("videoVolumeChanged", (data) => {
        this.$emit("video-volume-changed", data);
      });
      this.whiteBoardService.on("ready", () => {
        this.logWhiteBoardDiagnostic("诊断白板历史同步完成", {
          action: "whiteboard_ready",
        });
        this.setBoardReady(true);
        this.$emit("on-ready");
        this.whiteBoardService.setDrawEnable(this.isWhiteBoard);
        //获取白板当前数据
        this.setCurrentFileInfo(this.whiteBoardService.getFileInfo());
        // 把所有的课件插入到白板
        this.handleInsertCourseware();
        this.getCurrentFileInfo();
        if (this.isMGAppInPad || this.isHXApp) {
          this.whiteBoardService.setVideoControlEnable(this.controlPage);
        } else {
          this.whiteBoardService.setVideoControlEnable(
            !this.roomInfo.isStudent
          );
        }
      });
      this.whiteBoardService.on("addTranscodeFile", (fileId) => {
        this.logWhiteBoardDiagnostic("诊断白板新增转码文件回调", {
          action: "whiteboard_add_transcode_file_event",
          fileId,
        });
      });
      this.whiteBoardService.on("addH5PPTFile", (fileId) => {
        this.logWhiteBoardDiagnostic("诊断白板新增H5PPT文件回调", {
          action: "whiteboard_add_h5_ppt_file_event",
          fileId,
        });
      });
      this.whiteBoardService.on("h5PPTStatusChanged", (data) => {
        this.logWhiteBoardDiagnostic(
          "诊断白板H5PPT状态变化",
          {
            action: "whiteboard_h5_ppt_status_changed",
            status: data?.status,
            extraInfo: data?.extraInfo,
          },
          [4, 5, 6, 7, 8, 9].includes(data?.status) ? "error" : "info"
        );
      });
      this.whiteBoardService.on("warning", (data = {}) => {
        this.logWhiteBoardDiagnostic(
          "诊断白板告警",
          {
            action: "whiteboard_warning",
            code: data.code,
            msg: data.msg,
          },
          "error"
        );
      });
      this.whiteBoardService.on("diagnosticLog", (data = {}) => {
        this.logWhiteBoardDiagnostic("诊断白板SDK调用", data);
      });
      this.whiteBoardService.on("reportLog", (data = {}) => {
        const reportLog = parseSdkReportLog(data);
        const action =
          reportLog?.event ||
          reportLog?.action ||
          reportLog?.name ||
          data?.event ||
          data?.action ||
          data?.name ||
          "";
        const isH5PPTError = [
          "assets_loading_error",
          "assets_loading_timeout",
          "assets_ppt_internal_loading_timeout",
          "ppt_status_timeout",
          "runtime_error",
        ].some((key) => JSON.stringify(data).includes(key));
        this.logWhiteBoardDiagnostic(
          "诊断白板SDK内部日志",
          {
            action: "whiteboard_sdk_report_log",
            sdkReportAction: action,
            sdkReportSummary: {
              action,
              level: reportLog?.level,
              message: reportLog?.message,
              fileId: reportLog?.fileId || reportLog?.fid,
              url: reportLog?.url,
              status: reportLog?.status,
              retryTimes: reportLog?.retryTimes,
            },
            sdkReportLog: data,
          },
          isH5PPTError ? "error" : "info"
        );
      });
      this.whiteBoardService.on("error", (data = {}) => {
        this.logWhiteBoardDiagnostic(
          "诊断白板错误",
          {
            action: "whiteboard_error",
            code: data.code,
            msg: data.msg,
          },
          "error"
        );
        this.$emit("on-error");
      });

      this.whiteBoardService.on("tabGotoBoard", (fid) => {
        this.setCurrentFileInfo(this.whiteBoardService.getFileInfo(fid));
      });

      this.whiteBoardService.on("tabSwitchFile", (fid) => {
        this.setCurrentFileInfo(this.whiteBoardService.getFileInfo(fid));
        this.getCurrentFileInfo();
      });
      this.whiteBoardService.on("scaleBoard", () => {
        this.setCurrentFileInfo(this.whiteBoardService.getFileInfo());
      });
    },
    handleLog(log) {
      this.$emit("on-log", log);
    },
    logWhiteBoardDiagnostic(message, extra = {}, level = "info") {
      try {
        uploadLiveLog({
          message,
          level,
          tag: "whiteboard",
          extra: {
            component: "WhiteBoard",
            roomId: this.roomInfo?.id,
            isBoardReady: this.isBoardReady,
            currentFileId: this.whiteBoardService?.getCurrentFile?.(),
            currentFileInfo: this.whiteBoardService?.getFileInfo?.(),
            whiteBoardFileInfoList: this.whiteBoardService?.getFileInfoList?.(),
            runtimeInfo: getWhiteBoardRuntimeInfo(),
            ...extra,
          },
        });
      } catch (error) {
        console.warn("whiteboard_diagnostic_log_failed", error);
      }
    },
    addSyncData(realtimeData) {
      this.whiteBoardService.addSyncData(realtimeData);
    },
    // 把所有课件插入白板
    handleInsertCourseware() {
      const list = this.coursewareList;
      console.log("list____", list);
      list.forEach((item) => {
        if (item.roomFileId) {
          return;
        }
        let roomFileId = null;
        if (isVideo(item.doc_name)) {
          // 插入视频课件
          roomFileId = this.whiteBoardService.addVideoFile({
            url: item.transcode_result,
            title: item.doc_name,
          });
        } else if (isImage(item.doc_name)) {
          // 插入图片课件
          roomFileId = this.whiteBoardService.addImagesFile({
            urls: [item.transcode_result],
            title: item.doc_name,
          });
        } else {
          // 插入文件课件
          const config = {
            url: item.transcode_result,
            title: item.doc_name,
            pages: item.pages || 1,
            resolution: item.resolution,
          };
          this.logWhiteBoardDiagnostic("诊断白板历史课件插入请求", {
            action: "whiteboard_history_courseware_add_transcode_requested",
            fileId: item.id,
            fileName: item.doc_name,
            url: item.transcode_result,
            pages: item.pages,
            resolution: item.resolution,
            existingRoomFileId: item.roomFileId,
          });
          roomFileId = this.whiteBoardService.addTranscodeFile(config, false);
          this.logWhiteBoardDiagnostic("诊断白板历史课件插入返回", {
            action: "whiteboard_history_courseware_add_transcode_return",
            fileId: item.id,
            fileName: item.doc_name,
            roomFileId,
            targetFileInfo: this.whiteBoardService?.getFileInfo?.(roomFileId),
          });
        }
        if (roomFileId) {
          item.roomFileId = roomFileId;
        }
      });
      this.setRoomInfo({ doc: list });
    },
    // 获取当前文件信息
    getCurrentFileInfo() {
      const currentFile = this.whiteBoardService.getFileInfo();
      if (currentFile) {
        this.isVideo = isVideo(currentFile.downloadURL);
        const isWhiteBoard = this.whiteBoardService.isWhiteBoard(
          currentFile.fileType
        );
        if (isWhiteBoard) {
          this.handleUpdateWhiteboardType("whiteboard");
        } else {
          const data = {
            id: this.roomInfo.id,
            fileId: currentFile.fid,
          };
          localStorage.setItem("lastCourseware", JSON.stringify(data));
          this.handleUpdateWhiteboardType("courseware");
        }
      }
    },
    handleUpdateWhiteboardType(type) {
      this.setWhiteboardType(type);
      // this.imService.sendMGLiveRoomCustomMsg({
      //   cmdId: 2,
      //   data: {
      //     type: "whiteboardType",
      //     data: {
      //       type: type,
      //     },
      //   },
      // });
    },
  },
};
</script>

<style scoped lang="scss">
.comp-container__white-board {
  position: relative;
  width: 100%;
  flex: 1;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  min-height: 0; // 防止flex子元素溢出
  #comp-container__white-board-sketch ::v-deep {
    width: 100%;
    height: 100%;
    flex: 1;
    min-height: 0; // 防止内容溢出
    overflow: hidden;
    .tic_board_img_bg {
      width: 100% !important;
      height: 100% !important;
      object-fit: contain;
      object-position: center !important ;
    }
  }
  .bottom-controller-wrap {
    position: absolute;
    right: 20px;
    bottom: 12px;
    display: flex;
    align-items: center;
    z-index: 9;
  }
  .white-board-loading-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: all;
    .white-board-loading-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .white-board-loading-text {
      margin-top: 16px;
      font-size: 14px;
      color: #165dff;
      letter-spacing: 2px;
      text-align: center;
      user-select: none;
    }
    i.el-icon-loading {
      font-size: 48px;
      color: #165dff;
    }
  }
}
</style>
<style>
.comp-container__white-board .tic_board_img_bg {
  width: 100% !important;
}
</style>
